<template>
    <div class="o-tabBar u-fs14">
        <div class="o-tabBar__inner u-container">
            <div class="o-tabBar__items">
                <div class="o-tabBar__item" 
                     :class="{ '-active': item.active }" 
                     v-for="(item, index) in items" :key="index">
                    <a :href="item.route">
                        <i :class="`icon bx ${item.icon}`"></i>
                        <span>{{ item.label }}</span>
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref, watch } from 'vue';
import { inject } from 'vue';
import { useI18n } from 'vue-i18n';

const { t } = useI18n(); 
const currentPath = inject('currentPath');

const items = ref([
    { icon: 'bx-home-alt', label: t('home.home'), route: '#/home', active: true },
    { icon: 'bx-book-open', label: t('module.modules'), route: '#/modules', active: false },
    { icon: 'bx-help-circle', label: t('knowledgebase.knowledgebase'), route: '#/knowledgebase', active: false },
    { icon: 'bx-news', label: t('news.news'), route: '#/news', active: false }
]);

const updateActiveItems = (path) => {
    const normalizedPath = path === '#/' || path === '/#/' ? '#/home' : path;
    items.value.forEach(item => {
        item.active = normalizedPath.startsWith(item.route);
    });
};

updateActiveItems(currentPath.value);

watch(currentPath, (newPath) => {
    updateActiveItems(newPath);
});
</script>